module.exports = __webpack_public_path__ + "static/media/team-haley.8e718511.jpg";